import "./component-alert.scss";
import { html, nothing } from "lit";
import ComponentBase from "./component-base";
import * as bootstrap from "bootstrap";

export const ALERT_TYPES = {
  success: "success",
  warning: "warning",
  error: "danger",
};

class ComponentAlert extends ComponentBase {
  static get tagName() {
    return "component-alert";
  }

  constructor({ msg, type }) {
    super();
    this.msg = msg;
    this.type = type;
  }

  get classByType() {
    switch (this.type) {
      case "warning":
        return "alert-warning";
      case "danger":
        return "alert-warning";
      case "success":
      default:
        return "alert-success";
    }
  }

  render() {
    return html`
      <div
        class="alert ${this.classByType} alert-dismissible fade show"
        role="alert"
      >
        ${this.msg}
        ${this.type === ALERT_TYPES.success
          ? nothing
          : html`<button
              type="button"
              class="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>`}
      </div>
    `;
  }

  firstUpdated() {
    this.el = this.querySelector(".alert");
    this.instance = new bootstrap.Alert(this.el);
    if (this.type === ALERT_TYPES.success) {
      setTimeout(() => {
        this.instance.close();
      }, 3000);
    }
    this.el.addEventListener("closed.bs.alert", () => {
      this.remove();
    });
  }

  static Show({ msg, type }) {
    const alert = new this({ msg, type });
    document.body.appendChild(alert);
  }
}
ComponentAlert.Register();
export default ComponentAlert;
